module.exports = __webpack_public_path__ + "static/media/stairway.2d4e3ee9.png";